module.exports = __webpack_public_path__ + "static/media/CSK-horiz-desktop-hover@2x.768168a9.png";